/* eslint-disable no-unused-vars */

import _ from 'lodash';

import HSEEventSelector from '../hse/hse-event.selector';
import TasksSelector from '../tasks/tasks.selector';
import InspectionSelector from '../inspection/inspection.selector';
import CheckSelector from 'selectors/checks/check.selector';

export const getAllWorkOrdersAndInspections = async ({
  templatesIds = null,
  siteId = null,
  getDataFromCache = false,
  getWorkRequestData = false,
  recordsCount = false,
  store,
  query = null
}) => {
  if (!getDataFromCache) {
    const { auth } = store;
    const { userId } = auth;

    let apisCall = [
      await TasksSelector.getTasks({ siteId, store }),
      await InspectionSelector.getInspections({ siteId, store }),
      await HSEEventSelector.getHSEEvents({ siteId, store }),
      await CheckSelector.getAllChecks({ siteId, store })
    ];

    if (query === 'Check' || query === 'check')
      apisCall = [[], [], [], await CheckSelector.getAllChecks({ siteId, store })];
    else if (query === 'Inspection' || query === 'inspection')
      apisCall = [[], await InspectionSelector.getInspections({ siteId, store }), [], []];
    else if (query === 'Work Order' || query === 'workOrder')
      apisCall = [await TasksSelector.getTasks({ siteId, store }), [], [], []];
    else if (query === 'Work Request' || query === 'workRequest')
      apisCall = [await TasksSelector.getTasks({ siteId, store }), [], [], []];
    else if (query === 'hseEvents')
      apisCall = [[], [], await HSEEventSelector.getHSEEvents({ siteId, store }), []];

    let [tasks, inspections, hseEvents, checks] = await Promise.all(apisCall);

    if (query === 'Work Request' || query === 'workRequest')
      tasks = tasks?.filter((x) => x?.type === 'Work Request');
    else if (query === 'Work Order' || query === 'workOrder')
      tasks = tasks?.filter((x) => x?.type === 'Work Order');

    const allAssignedWorkOrders = _.isEmpty(templatesIds)
      ? tasks?.filter((task) =>
          task.newWorkOrder && task?.status !== 'To do'
            ? task?.responsible?.[0]?.woUserRequestId === userId
              ? true
              : false
            : task?.status === 'Synced'
            ? !task?.isNew
              ? true
              : false
            : !task.newWorkRequest
        )
      : tasks?.filter((task) =>
          task.newWorkOrder && task?.status !== 'To do'
            ? task?.responsible?.[0]?.woUserRequestId === userId
              ? true
              : false
            : task?.status === 'Synced'
            ? !task?.isNew
              ? true
              : false
            : !task.newWorkRequest && templatesIds?.includes(task?.rtNumber)
        );

    const allAssignedInspections = inspections;
    const allAssignedChecks = checks;

    const newWorkRequestList =
      tasks?.filter((task) => task.newWorkRequest || task?.entityType === 'WorkRequest') || [];

    const newWorkOrderList = _.isEmpty(templatesIds)
      ? tasks?.filter((task) =>
          (task.newWorkOrder || task?.entityType === 'WorkOrder') &&
          task?.responsible?.[0]?.woUserRequestId !== userId &&
          task?.status !== 'To do' &&
          task?.status !== 'Synced'
            ? true
            : task?.status === 'Synced' && task?.isNew && task?.entityType !== 'WorkRequest'
            ? true
            : false
        )
      : tasks?.filter((task) =>
          (task.newWorkOrder || task?.entityType === 'WorkOrder') &&
          task?.responsible?.[0]?.woUserRequestId !== userId &&
          task?.status !== 'To do' &&
          task?.status !== 'Synced'
            ? true
            : task?.status === 'Synced' && task?.isNew && task?.entityType !== 'WorkRequest'
            ? true
            : templatesIds?.includes(task?.rtNumber)
        );

    let onDemandRecordList = [];

    onDemandRecordList = [...newWorkRequestList, ...hseEvents, ...newWorkOrderList];

    return {
      assignedTasksList: [
        ...allAssignedWorkOrders,
        ...allAssignedInspections,
        ...allAssignedChecks
      ],
      newWorkRequestList: newWorkRequestList || [],
      hseEvents,
      onDemandRecordList,
      newWorkOrderList: newWorkOrderList
    };
  } else {
    let { tasks, inspection, checks, hseEvents, auth } = store;

    let { tasksList = [] } = tasks;
    let { inspectionsList = [] } = inspection;
    let { checksList = [] } = checks;
    let { HSEEventList = [] } = hseEvents;
    const { userId } = auth;

    if (query === 'Check' || query === 'check') {
      tasksList = [];
      inspectionsList = [];
      HSEEventList = [];
      // checksList = [];
    } else if (query === 'Inspection' || query === 'inspection') {
      tasksList = [];
      //  inspectionsList = [];
      HSEEventList = [];
      checksList = [];
    } else if (query === 'Work Order' || query === 'workOrder') {
      tasksList = tasksList?.filter((x) => x?.type === 'Work Order');
      inspectionsList = [];
      HSEEventList = [];
      checksList = [];
    } else if (query === 'Work Request' || query === 'workRequest') {
      tasksList = tasksList?.filter((x) => x?.type === 'Work Request');
      inspectionsList = [];
      HSEEventList = [];
      checksList = [];
    } else if (query === 'hseEvents') {
      tasksList = [];
      inspectionsList = [];
      // HSEEventList = [];
      checksList = [];
    }

    tasksList = siteId
      ? tasksList?.filter(
          (t) =>
            t?.siteId === siteId ||
            t?.relatedAssetId === siteId ||
            t?.primaryAssetId === siteId ||
            t?.sites?.includes(siteId)
        )
      : tasksList;

    inspectionsList = siteId
      ? inspectionsList?.filter(
          (t) =>
            t?.siteId === siteId ||
            t?.relatedAssetId === siteId ||
            t?.primaryAssetId === siteId ||
            t?.sites?.includes(siteId)
        )
      : inspectionsList;

    checksList = siteId
      ? checksList?.filter(
          (t) =>
            t?.siteId === siteId ||
            t?.relatedAssetId === siteId ||
            t?.primaryAssetId === siteId ||
            t?.sites?.includes(siteId)
        )
      : checksList;

    const allAssignedWorkOrders = _.isEmpty(templatesIds)
      ? tasksList?.filter((task) =>
          task.newWorkOrder && task?.status !== 'To do'
            ? task?.responsible?.[0]?.woUserRequestId === userId
              ? true
              : false
            : task?.status === 'Synced'
            ? !task?.isNew
              ? true
              : false
            : !task.newWorkRequest
        )
      : tasksList?.filter((task) =>
          task.newWorkOrder && task?.status !== 'To do'
            ? task?.responsible?.[0]?.woUserRequestId === userId
              ? true
              : false
            : task?.status === 'Synced'
            ? !task?.isNew
              ? true
              : false
            : !task.newWorkRequest && templatesIds?.includes(task?.rtNumber)
        );

    const allAssignedInspections = inspectionsList;
    const allAssignedChecks = checksList;

    const newWorkRequestList =
      tasksList?.filter((task) => task.newWorkRequest || task?.entityType === 'WorkRequest') || [];

    let onDemandRecordList = [];

    let newHseEventCount = HSEEventList?.filter((x) =>
      siteId
        ? x?.siteId === siteId ||
          x?.relatedAssetId === siteId ||
          x?.primaryAssetId === siteId ||
          x?.sites?.includes(siteId)
        : true
    );

    let newWorkRequestAndWorkOrder = _.isEmpty(templatesIds)
      ? tasksList?.filter((task) =>
          (task.newWorkOrder || task?.entityType === 'WorkOrder') &&
          task?.responsible?.[0]?.woUserRequestId !== userId &&
          task?.status !== 'To do' &&
          task?.status !== 'Synced'
            ? true
            : task?.status === 'Synced' && task?.isNew && task?.entityType !== 'WorkRequest'
            ? true
            : false
        )
      : tasks?.tasksList?.filter(
          (task) =>
            (task.newWorkOrder || task.newWorkRequest) && templatesIds?.includes(task?.rtNumber)
        );

    onDemandRecordList = [
      ...newWorkRequestList,
      ...newHseEventCount,
      ...newWorkRequestAndWorkOrder
    ];

    return {
      assignedTasksList: [
        ...allAssignedWorkOrders,
        ...allAssignedInspections,
        ...allAssignedChecks
      ],
      newWorkRequestList: newWorkRequestList || [],
      onDemandRecordList
    };
  }
};
